export const consentManagement = {
  consentManagementDialog: {
    labelDecline: 'Withdraw',
    labelCancel: 'Cancel',
    termsAndConditions: 'Terms and Conditions',
    noTermsConditions_line1: 'Do you really want to withdraw your consent to the General Terms and Conditions?',
    noTermsConditions_line2: 'This leads to an immediate logout from the webshop.',
  }
};
